<p-table 
    [columns]="columns"
    [value]="data" 
    [paginator]="true" 
    [scrollable]="true" 
    [scrollHeight]="tableScrollHeight" 
    [rows]="pageSize"
    [first]="firstPage"
    [totalRecords]="totalCount"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [(selection)]="selectedProject"
    [lazy]="true"
    (onLazyLoad)="onPageChange($event)"
    >
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngIf="haveTableChecboxes" style="width: 24px">
                <p-tableHeaderCheckbox (click)="rowSelection()"></p-tableHeaderCheckbox>
            </th>
            <th [ngClass]="{'editableColHead': editableListing}" *ngFor="let col of columns" [ngStyle]="!editableListing ? getStyle(col):getEditableTableStyle(col)">
                {{col.header}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-rowData let-columns="columns" let-ri="rowIndex">
    <ng-template #defaultTemplate>
        <tr [pEditableRow]="rowData" [pEditableRow]="editingRowId === product.id || !rowData.id">
            <td *ngIf="haveTableChecboxes">
                <p-tableCheckbox [value]="rowData" (click)="rowSelection()"></p-tableCheckbox>
            </td>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.field !== ''; else otherColumn">
                    <ng-container [ngSwitch]="col.field">
                        <!-- for status -->
                        <ng-container *ngSwitchCase="'is_active'">
                            <span class="status" [ngClass]="{'active': rowData[col.field]}">
                                {{
                                    rowData[col.field] ? 'Active':'Inactive'
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'user'">
                            <span class="line-clamp-1">
                                {{
                                    rowData[col.field] = 'LinkedIn Connected'
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'site'">
                            <span class="line-clamp-1">
                                {{
                                    rowData[col.field] === 'Facebook' ? 'Facebook Connected' : rowData[col.field]
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'permissions'">
                            <div class="permission-col">
                                <ng-container *ngFor="let item of rowData[col.field]; let i = index">
                                    <!-- Display the first 2 items -->
                                    <p-badge *ngIf="i < 2" [value]="item.name" severity="info"></p-badge>
                                </ng-container>
                                <!-- If more than 2 items, show 'More' link -->
                                <span class="more" *ngIf="rowData[col.field].length > 2" 
                                   #overlayLink 
                                   (click)="toggleOverlayPanel($event, overlayPanel)">
                                    +{{ rowData[col.field].length - 2 }} more
                                </span>
                                <!-- OverlayPanel for remaining items -->
                                <p-overlayPanel
                                    #overlayPanel 
                                    (onShow)="onOverlayShow(overlayPanel)"
                                    (onHide)="onOverlayHide(overlayPanel)">
                                    <div  class="permission-overlay">
                                        <!-- Show items starting from index 2 -->
                                        <p-badge *ngFor="let item of rowData[col.field]; let i = index" [value]="item.name" severity="info"></p-badge>
                                    </div>
                                </p-overlayPanel>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span class="line-clamp-1" *ngIf="!editableListing">
                                {{rowData[col.field]}}
                            </span>
                            <ng-container *ngIf="editableListing">
                                <ng-container *ngIf="editingRowId === product.id || !rowData.id">
                                    <input type="text" #inputField pInputText [(ngModel)]="rowData[col.field]" />
                                </ng-container>
                                <ng-container *ngIf="editingRowId !== product.id">
                                    <span *ngIf="rowData.id" [innerHTML]="rowData[col.field]"></span>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                      </ng-container>
                </ng-container>
                <ng-template #otherColumn>
                    <ng-container *ngIf="!(editingRowId === (product.id || !rowData.id || rowData.post_id))">
                        <button *ngIf="!editableListing"
                          pButton
                          pRipple
                          type="button"
                          [icon]="'pi pi-eye'"
                          pTooltip="View" 
                          tooltipPosition="top"
                          (click)="viewData(rowData)"
                          class="p-button-rounded btn-small-round p-button-text"
                        ></button>
                        <ng-container *ngIf="haveRowEditButton">
                          <button
                              pButton
                              pRipple
                              type="button"
                              [disabled]="addRowButtonDisabled"
                              [icon]="'pi pi-pencil'"
                              pTooltip="Edit" 
                              tooltipPosition="top"
                              (click)="editData(product)"
                              class="p-button-rounded btn-small-round  p-button-text ml-2"
                          ></button>
                        </ng-container>
                        <ng-container *ngIf="haveRowDeleteButton">
                          <button
                              pButton
                              pRipple
                              type="button"
                              [icon]="'pi pi-trash'"
                              pTooltip="Delete" 
                              [disabled]="addRowButtonDisabled"
                              tooltipPosition="top"
                              (click)="viewData(rowData)"
                              class="p-button-rounded btn-small-round p-button-text ml-2"
                          ></button>
                        </ng-container>
                    </ng-container>



                  <ng-container *ngIf="editingRowId === (product.id || !rowData.id || rowData.post_id)">
                    <button pButton pRipple type="button" pSaveEditableRow
                        icon="pi pi-check"
                        class="p-button-rounded btn-small-round  p-button-text"
                        tooltipPosition="bottom"
                        (click)="saveRowData(product)"></button>
                    <button pButton pRipple type="button" pCancelEditableRow
                        icon="pi pi-times"
                        class="p-button-rounded btn-small-round  p-button-text ml-2" 
                        tooltipPosition="bottom"
                        (click)="resetRowData(data,product)"></button>
                </ng-container>
                </ng-template>
              </td>
        </tr>
    </ng-template>
    <ng-container *ngTemplateOutlet="customBodyTemplate ? customBodyTemplate : defaultTemplate" ></ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr class="table-null-case">
          <td class="text-center" [attr.colspan]="haveTableChecboxes ? columns.length + 1:columns.length"><i class="svg null-icon"></i><br/> {{tableNullData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-toast/>
<!-- <p-confirmDialog/> -->